import React, { useContext, useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./styles.css";

// import required modules
import {
    Pagination,
    Navigation,
    Autoplay,
    EffectCoverflow,
} from "swiper/modules";
import DashboardContext from "../../context/DashboardContext";

const images = [
    "https://fastly.picsum.photos/id/74/200/200.jpg?hmac=vocZAjFd_aCjJJ-cIS28YxzM2nwLpe_EYBYW95lrzUI",
    "https://fastly.picsum.photos/id/948/200/200.jpg?hmac=h64Z3zl6jLB_DtaWe83fhSQY-r_Sum7pndIJrZZ9rtQ",
    "https://fastly.picsum.photos/id/181/200/200.jpg?hmac=hxgS3WEn2EsuxbTrdq37OVbnajtIHlPXzTKW0X_Gu-s",
    "https://fastly.picsum.photos/id/993/200/200.jpg?hmac=CEiN6Eewa6wBwf3bGpqqpFUAi5-u8XXTZ76fqI6gMXo",
    "https://fastly.picsum.photos/id/222/200/200.jpg?hmac=GngU-e1fHxK6MMBinwEkzsh8sMkjssl_vp8G6vJrb8U",
];

export default function Carousel2() {
    const { setPopupImage } = useContext(DashboardContext);
    const leftRef = useRef(null);
    const rightRef = useRef(null);
    return (
        <div
            style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-evenly",
                padding: "10px",
            }}
        >
            <div ref={leftRef} className="cursor-pointer">
                <FaChevronLeft size={24} color="var(--secondary-2)" />
            </div>
            <Swiper
                slidesPerView={"3"}
                // autoplay={{
                //   delay:3000,
                //   disableOnInteraction:false
                // }}
                loop={false}
                effect={'coverflow'}
                centeredSlides={true}
                spaceBetween={10}
                initialSlide={'2'}
                navigation={{
                    prevEl: leftRef.current,
                    nextEl: rightRef.current,
                }}
                coverflowEffect={{
                    rotate: 0,
                    stretch: 0,
                    depth: 200,
                    modifier: 3,
                    slideShadows: true,
                }}
                pagination={{
                    clickable: true,
                }}
                modules={[Navigation, Pagination, Autoplay, EffectCoverflow]}
                className="mySwiper"
            >
                {images.map((img) => {
                    return (
                        <SwiperSlide key={img}>
                            <img
                                src={img}
                                alt="sliderImage"
                                width="100%"
                                onClick={() => setPopupImage(img)}
                            />
                        </SwiperSlide>
                    );
                })}
            </Swiper>
            <div ref={rightRef} className="cursor-pointer mr-2">
                <FaChevronRight size={24} color="var(--secondary-2)" />
            </div>
        </div>
    );
}
